import { NgModule } from '@angular/core';
import {
	SectionComponent,
	SectionContentDirective,
	SectionHeaderActionsDirective,
	SectionHeaderDirective
} from './section.component';
import { SectionsComponent } from './sections.component';
import { CommonModule } from '@angular/common';
import { EdAssistUIIconModule } from '@edassist-ui/icon';

@NgModule({
	exports: [
		SectionComponent,
		SectionsComponent,
		SectionContentDirective,
		SectionHeaderActionsDirective,
		SectionHeaderDirective
	],
	imports: [CommonModule, EdAssistUIIconModule],
	declarations: [
		SectionComponent,
		SectionsComponent,
		SectionContentDirective,
		SectionHeaderActionsDirective,
		SectionHeaderDirective
	]
})
class EdAssistUISectionModule {}

export {
	EdAssistUISectionModule,
	SectionComponent,
	SectionsComponent,
	SectionContentDirective,
	SectionHeaderActionsDirective,
	SectionHeaderDirective
};
